import EmptyRequestList from './empty-request-list';

export default EmptyRequestList;